export const preferencesLink = '/settings';
export const profileLink = '/user-settings';
export const signOutLink = '/auth/sign_out';
export const termsLink = '/terms';
export const accountAdminLink = (id) => `/pleroma/admin/#/users/${id}/`;
export const statusAdminLink = (account_id, status_id) => `/pleroma/admin/#/users/${account_id}/`;
export const filterEditLink = undefined; // (id) => `/filters/${id}/edit`;
export const relationshipsLink = undefined; // = '/relationships';
export const securityLink = undefined ; // = '/auth/edit';
